import { ReactComponent as MenuBar } from "images/icons/menu-mobile.svg";
import classes from "./MobileMenuButton.module.css";

const MobileMenuButton = ({ setNavOpen }) => (
  <div className={classes["mobile-toggler"]}>
    <a onClick={() => setNavOpen(true)}>
      <MenuBar />
    </a>
  </div>
);

export default MobileMenuButton;
